import * as React from 'react';
import * as style from './Builders.css';

import { INewbuildingBuilderSchema } from '../../../../repositories/newbuilding-card/entities/builder/NewbuildingBuilderSchema';
import { Builder } from '../Builder';

export interface IBuildersProps {
  builders?: INewbuildingBuilderSchema[] | null;
  newbuildingDisplayName?: string;
}

export const Builders: React.FC<IBuildersProps> = props => {
  const { builders } = props;

  if (!builders || builders.length < 1) {
    return null;
  }

  return (
    <div className={style['builders']} data-mark={'Builders'}>
      {builders.map(builder => [<Builder key={builder.id} builder={builder} />])}
    </div>
  );
};
